import { render, staticRenderFns } from "./AbacusTaskInfo.vue?vue&type=template&id=7d4132c5&scoped=true"
import script from "./AbacusTaskInfo.vue?vue&type=script&lang=js"
export * from "./AbacusTaskInfo.vue?vue&type=script&lang=js"
import style0 from "./AbacusTaskInfo.vue?vue&type=style&index=0&id=7d4132c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4132c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VFlex,VLayout,VList,VListItemContent})
